module.exports = __webpack_public_path__ + "img/empty-icon.ca885151.png";